import { APIs, API_BASE_URL, SERVICEURL } from '../constants/Constants';
import { _base64ToArrayBuffer } from './StudyViewerService';
import axiosInterceptor from '../helpers/Interceptor';

export const getSearchedOrchestratorList = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ORCHESTRATORSEARCH,
      {
        data: body,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getOrchestratorList = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ORCHESTRATORLOGSLIST,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const downloadOrchestratorCSVService = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADORCHESTRATORLOG,
      { data: body },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    if (response.status === 200) {
      const fileData = _base64ToArrayBuffer(response.data.data.data);
      const file = new Blob([fileData]);
      const url = window.URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', response.data.data.filename);
      document.body.appendChild(link);
      link.click();
    }
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
